import ReactDOMServer from 'react-dom/server';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { startCase } from 'lodash';
import React, { FC } from 'react';
import { getChartColor } from 'wb-reddit/app/routes/superGrid/actionRow/charts/utils';
import { RedditLevel } from 'wb-reddit/app/routes/superGrid/utils';
import { ChartTooltip } from '@aleph/shared-components';

type ColumnChartProps = {
	chartData: {
		kpi: number,
		breakdown: string,
		currency?: string,
	}[]
	isCurrency: boolean
};

const RedditDashboardColumnChart: FC<ColumnChartProps> = ({ chartData, isCurrency }) => {
	const optionColors = new Array(10).fill(null).map((_, idx) => getChartColor({ idx, level: RedditLevel.AD_ACCOUNT }));

	return (
		<HighchartsReact
			highcharts={Highcharts}
			containerProps={{ style: { height: '100%', flex: 1 } }}
			options={{
				title:         undefined,
				accessibility: {
					enabled: false,
				},
				chart: {
					backgroundColor: null,
					spacingBottom:   0,
					spacingLeft:     0,
					spacingRight:    0,
				},
				legend: {
					enabled: false,
				},
				plotOptions: {
					column: {
						pointWidth: 8,
						states:     { hover: { brightness: 0 } },
					},
				},
				credits: {
					enabled: false,
				},
				yAxis: {
					title:             undefined,
					tickAmount:        4,
					gridLineDashStyle: 'ShortDash',
					labels:            {
						style: {
							color: optionColors[0],
						},
					},
				},
				xAxis: {
					tickInterval: 1,
					categories:   chartData?.map(stat => startCase(stat?.breakdown?.toLowerCase?.())) ?? [],
					labels:       {
						rotation: 0,
					},
				},
				tooltip: {
					shape:           'square',
					backgroundColor: 'transparent',
					borderWidth:     0,
					distance:        0,
					shadow:          false,
					useHTML:         true,
					outside:         true,
					className:       'super-grid-chart-tooltip',
					formatter() {
						try {
							return ReactDOMServer.renderToStaticMarkup(
								<ChartTooltip {...this}/>,
							);
						} catch (e) {
							// TODO handle this
							console.error(e);

							return '';
						}
					},
				},
				series: [{
					type:         'column',
					colorByPoint: true,
					animation:    false,
					data:         chartData?.map(stat => ({
						color:    optionColors[0],
						name:     startCase(stat?.breakdown?.toLowerCase?.()),
						y:        stat?.kpi,
						currency: isCurrency ? stat?.currency : '',
					})) ?? [],
				}],
			}}
		/>
	);
};

export default RedditDashboardColumnChart;
